<nav class="breadcrumb-nav" [attr.aria-label]="'breadcrumb.ariaLabel' | transloco">
  @if (breadcrumbs$ | async; as breadcrumbs) {
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item">
        <a routerLink="/" class="breadcrumb-link" [attr.aria-label]="'nav.home' | transloco">
          <mat-icon class="breadcrumb-icon">home</mat-icon>
        </a>
        @if (breadcrumbs.length > 0) {
          <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
        }
      </li>
      @for (breadcrumb of breadcrumbs; track trackBreadcrumb($index, breadcrumb); let isLast = $last) {
        <li class="breadcrumb-item" [class.breadcrumb-current]="isLast">
          @if (!isLast) {
            <a
              class="breadcrumb-link"
              [routerLink]="breadcrumb.url"
              [class.has-icon]="!!breadcrumb.icon"
              [attr.aria-current]="isLast ? 'page' : null">
              @if (breadcrumb.icon) {
                <mat-icon class="breadcrumb-icon">{{ breadcrumb.icon }}</mat-icon>
              }
              <span class="breadcrumb-label">
                @if (breadcrumb.labelKey) {
                  {{ breadcrumb.labelKey | transloco: breadcrumb.labelParams }}
                } @else if (isObservable(breadcrumb.label)) {
                  {{ breadcrumb.label | async }}
                } @else {
                  {{ breadcrumb.label }}
                }
              </span>
            </a>
            <mat-icon class="breadcrumb-separator">chevron_right</mat-icon>
          } @else {
            <span class="breadcrumb-current-text" [class.has-icon]="!!breadcrumb.icon">
              @if (breadcrumb.icon) {
                <mat-icon class="breadcrumb-icon">{{ breadcrumb.icon }}</mat-icon>
              }
              <span class="breadcrumb-label">
                @if (breadcrumb.labelKey) {
                  {{ breadcrumb.labelKey | transloco: breadcrumb.labelParams }}
                } @else if (isObservable(breadcrumb.label)) {
                  {{ breadcrumb.label | async }}
                } @else {
                  {{ breadcrumb.label }}
                }
              </span>
            </span>
          }
        </li>
      }
    </ol>
  }
</nav>
